/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * what's the status of deliverable collection for this entity. dictates if we generate tasks according to collection
 * plans & schedule triggers.
 */
export enum DeliverableCollectionStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}
